import React from 'react';
import T from 'prop-types';
import { CSSTransition } from 'react-transition-group';

const Animation = ({
  show,
  children,
  animationType = 'fade-in-out',
  timeout = 300,
  unmountOnExit = true,
  onEnter,
  onEntering,
  onEntered,
  onExit,
  onExiting,
  onExited,
}) => (
  <CSSTransition
    in={show}
    timeout={timeout}
    classNames={animationType}
    unmountOnExit={unmountOnExit}
    onEnter={onEnter}
    onEntering={onEntering}
    onEntered={onEntered}
    onExit={onExit}
    onExiting={onExiting}
    onExited={onExited}
  >
    {children}
  </CSSTransition>
);

Animation.propTypes = {
  show: T.bool.isRequired,
  children: T.node.isRequired,
  animationType: T.string,
  timeout: T.number,
  unmountOnExit: T.bool,
  onEnter: T.func,
  onEntering: T.func,
  onEntered: T.func,
  onExit: T.func,
  onExiting: T.func,
  onExited: T.func,
};

export default Animation;
